import React, { useState, useEffect } from "react"
import { Card, CardBody, Collapse } from "reactstrap"
import { useNavigate } from "react-router-dom"
import CustomHeaderTitle from "components/Common/CustomHeaderTitle"
import SAlert from "components/Alert"

import ProvinceConsumptionItems from "./ConsumptionItems"
import ProvinceConsumptionFilter from "./ConsumptionFilter"
import ProvinceConsumptionHeaderTitle from "./HeaderTitle"

const ProvinceConsumptionListComponent = ({
  data,
  error,
  loading,
  onAdvancedSearchSubmit,
  onSubmit,
  onUpdateFunc,
  onBatchSave,
  filters,
  storeStatus,
  onExport,
  exportLoading,
}) => {
  const navigate = useNavigate()
  const [filterOpen, setFilterOpen] = useState(false)
  const [form, setForm] = useState({})
  const [quantity, setQuantity] = useState([])
  const [hasPendingEntries, setHasPendingEntries] = useState(false)
  const [pendingEntriesCount, setPendingEntriesCount] = useState(0)

  // Handle pending entries state change from child component
  const handlePendingEntriesChange = (hasPending, count) => {
    setHasPendingEntries(hasPending)
    setPendingEntriesCount(count)
  }

  // Close filter automatically when pending entries are added
  useEffect(() => {
    if (hasPendingEntries && filterOpen) {
      setFilterOpen(false)
    }
  }, [hasPendingEntries])

  // Callback function to toggle the advanced search filter visibility when the button is clicked
  const onAdvancedSearchHandler = async (result) => {
    // If trying to open filter and there are pending entries, show warning
    if (result && hasPendingEntries) {
      await SAlert({
        title: "Warning!",
        text: `You have ${pendingEntriesCount} unsaved pending ${pendingEntriesCount === 1 ? 'entry' : 'entries'}. Please save or clear them before changing filters.`,
        icon: "warning",
      })
      return // Prevent filter from opening
    }
    setFilterOpen(result)
  }

  // Trigger value when onSubmitQuantity called
  const onSubmitQuantity = value => {
    onSubmit(value)
  }

  return (
    <React.Fragment>
      <Card>
        <CardBody>
          {/*
            CustomHeaderTitle Component Props:
            
            - loading: Boolean flag to display loading state
            - title: String to display as the header title
            - rowCount: Boolean to show/hide the row number selector
            - lgColumn: Number to control the width of columns based on layout needs
            - onChangeRowNumber: Callback function to handle row number selection change
            - orderingList: Boolean to show/hide ordering dropdown
            - onChangeOrdering: Callback function triggered when the ordering option is changed
            - searchBox: Boolean to show/hide search input box
            - onSearchHandler: Function called on key up in the search box
            - rightBtn: Boolean to show/hide right-side button (for example, a back button)
            - rightBtnTitle: String for setting the right button's label
            - rightBtnRoute: Route for the right button's navigation
            - exportBtn: Boolean to show/hide export button
            - onExportBtnClick: Callback for when the export button is clicked
            - exportBtnLoading: Boolean flag to show loading state during export functionality
            - advnacedSearchBtn: Boolean to show/hide advanced search button
            - advnacedSearchBtnTitle: String to display the advanced search button label
            - onAdvancedSearch: Callback function when the advanced search button is clicked (used to toggle collapse)
            - orderingOptions: Array of options to populate the ordering dropdown (value and name pair)
          */}
          <CustomHeaderTitle
            loading={loading}
            title={"List"}
            rowCount={false}
            orderingList={false}
            searchBox={false}
            advnacedSearchBtn={true}
            exportBtn={data}
            exportBtnLoading={exportLoading}
            onExportBtnClick={onExport}
            advnacedSearchBtnTitle={
              hasPendingEntries 
                ? `Add Consumption (${pendingEntriesCount} pending)` 
                : "Add Consumption"
            }
            onAdvancedSearch={onAdvancedSearchHandler}
          />
          {hasPendingEntries && (
            <div className="alert alert-warning mt-2 mb-0" role="alert">
              <i className="mdi mdi-alert-outline me-2"></i>
              You have <strong>{pendingEntriesCount}</strong> unsaved pending {pendingEntriesCount === 1 ? 'entry' : 'entries'}. 
              Please save or clear them before changing filters.
            </div>
          )}
          <Collapse isOpen={filterOpen}>
            {/* Province Consumption Filter Component  */}
            <ProvinceConsumptionFilter
              loading={loading}
              onAdvancedSearchSubmit={onAdvancedSearchSubmit}
              setQuantity={setQuantity}
              error={error}
            />
          </Collapse>
          {/* Province Consumption healer Title */}
          <ProvinceConsumptionHeaderTitle
            filters={filters}
            storeStatus={storeStatus}
          />
          {/* Province Consumption Items Component  */}
          <ProvinceConsumptionItems
            data={data}
            onSubmitQuantity={onSubmitQuantity}
            form={form}
            setForm={setForm}
            quantity={quantity}
            setQuantity={setQuantity}
            onUpdateFunc={onUpdateFunc}
            onBatchSave={onBatchSave}
            filters={filters}
            storeStatus={storeStatus}
            onPendingEntriesChange={handlePendingEntriesChange}
          />
        </CardBody>
      </Card>
    </React.Fragment>
  )
}

export default ProvinceConsumptionListComponent
